import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import BlogSection from '../../components/BlogSection'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import { Helmet } from 'react-helmet';
import blogsBanner from '../../images/banners/blogs.webp'


const BlogPage =() => {
    return(
        <Fragment>
            <Helmet>
                <title>Blog | Dar-ul-Quran Academy UK</title>
                <meta name="description" content="Read the latest news, tips, and stories from Dar-ul-Quran Academy. Stay updated on online Quran learning for UK families." />
                <link rel="canonical" href="https://www.thedarulquran.com/blog" />
            </Helmet>
            <Navbar/>
            <PageTitle pageTitle={'Latest News'} pagesub={'Blog'} backgroundImage={blogsBanner} hideText={true}/> 
            <BlogSection blogImg1={require('../../images/blog/blog1.webp')} blogImg2={require('../../images/blog/blog2.webp')} />
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default BlogPage;

